import { Logo } from '@/components/ui/Logo';

interface AuthShellProps {
    children: React.ReactNode;
    /** Hide the "Authorized use only" notice — useful on invite/reset pages where legal
     * monitoring language would be jarring to a first-time user activating an account. */
    showNotice?: boolean;
}

export function AuthShell({ children, showNotice = true }: AuthShellProps) {
    return (
        <div className="min-h-screen flex flex-col items-center justify-center bg-sidebar p-4">
            <div className="w-full max-w-md bg-surface border border-border rounded-xl shadow-xl p-10">
                <div className="flex justify-center mb-6">
                    <Logo variant="full" tone="black" size="md" />
                </div>
                {children}
            </div>
            {showNotice && <AuthorizedUseNotice />}
        </div>
    );
}

function AuthorizedUseNotice() {
    return (
        <div
            role="note"
            aria-label="Authorized use notice"
            className="w-full max-w-md mt-6 text-[11px] leading-relaxed text-sidebar-text"
        >
            <p className="font-semibold text-text-inverse mb-1">Authorized use only</p>
            <p>
                This system contains protected health information (PHI) and is
                restricted to authorized users. All access and activity is logged
                and may be audited. Unauthorized access, use, or disclosure is
                prohibited and may result in civil and criminal penalties under
                HIPAA and other applicable laws. By signing in, you acknowledge
                this notice and consent to monitoring.
            </p>
        </div>
    );
}
